module.exports = {
  "dof-confirm": {
    "position": "fixed",
    "width": "750",
    "background": "#ffffff",
    "borderTopLeftRadius": "32",
    "borderTopRightRadius": "32"
  },
  "bottom": {
    "left": 0,
    "right": 0
  },
  "confirm-title": {
    "lineHeight": "88",
    "height": "88",
    "textAlign": "center",
    "color": "#1E2E37",
    "fontSize": "36",
    "backgroundColor": "#ffffff",
    "borderTopLeftRadius": "32",
    "borderTopRightRadius": "32"
  },
  "confirm-content-wrapper": {
    "paddingTop": "10",
    "paddingBottom": "31",
    "paddingLeft": "21",
    "paddingRight": "21",
    "display": "flex",
    "justifyContent": "center"
  },
  "confirm-content": {
    "color": "#020f13",
    "fontSize": "28",
    "lineHeight": "30",
    "content::after": "''",
    "display::after": "inline-block",
    "width::after": 100
  },
  "confirm-buttons": {
    "overflow": "hidden",
    "position": "relative",
    "paddingTop": "14",
    "backgroundColor": "#f2f2f2",
    "textAlign": "center",
    "fontSize": "36",
    "flexDirection": "row"
  },
  "confirm-button-left": {
    "width": "375",
    "textAlign": "center",
    "flex": 1,
    "alignItems": "center",
    "justifyContent": "center",
    "backgroundColor": "#ffffff",
    "borderRightWidth": "1",
    "borderRightColor": "#e5e5e5"
  },
  "confirm-button-right": {
    "width": "375",
    "textAlign": "center",
    "flex": 1,
    "alignItems": "center",
    "justifyContent": "center",
    "backgroundColor": "#ffffff"
  },
  "left-button": {
    "lineHeight": "100",
    "fontSize": "36",
    "color": "#232323"
  },
  "right-button": {
    "lineHeight": "100",
    "fontSize": "36",
    "color": "#1E2E37"
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-163fc8c6!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-confirm/index.vue
// module id = 426
// module chunks = 0 1